export default "__VITE_ASSET__CdmPBBcl__"